import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export const getSimModules = async (currentPage, itemsPerPage, filters = {}) => {
    try {
        const response = await axios.get(`${apiUrl}/sim-modules/all`, {
            params: {
                page: currentPage,
                limit: itemsPerPage,
                ...filters,
            },
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error al obtener los modulos sim: ', error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};